import { render, staticRenderFns } from "./KommunetorgetQuestionPage.vue?vue&type=template&id=5efaceed&"
import script from "./KommunetorgetQuestionPage.vue?vue&type=script&lang=js&"
export * from "./KommunetorgetQuestionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5efaceed')) {
      api.createRecord('5efaceed', component.options)
    } else {
      api.reload('5efaceed', component.options)
    }
    module.hot.accept("./KommunetorgetQuestionPage.vue?vue&type=template&id=5efaceed&", function () {
      api.rerender('5efaceed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/KommunetorgetQuestionPage.vue"
export default component.exports